import { EvtHeader } from "components/header";
import React from "react";
import TechStackForm from "../form";

const CreateTechStack = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Tech Stack" />
      <div className="p-6 max-w-2xl">
        <TechStackForm />
      </div>
    </div>
  );
};

export default CreateTechStack;
